export default __webpack_public_path__ + "static/media/edit.8f26460a.svg";